<template>
  <div>
    <template v-if="summaryItems">
      <v-container fluid grid-list-lg px-0 style="width: 100%">
        <v-layout row wrap grid-list-lg>
          <v-flex v-for="(value, key) in summaryItems" :key="key" xs4>
            <BroadcastTotalQtyByStatusCard :title="key" :quantity="value" />
          </v-flex>
        </v-layout>
      </v-container>
    </template>
  </div>
</template>

<script>
import BroadcastTotalQtyByStatusCard from '@/features/tcp/Broadcast/BroadcastTotalQtyByStatusCard'
export default {
  components: {
    BroadcastTotalQtyByStatusCard
  },
  props: {
    items: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      summaryItems: null
    }
  },
  watch: {
    items: {
      deep: true,
      handler() {
        if (this.items) {
          this.summaryItems = this.items
        }
      }
    }
  },
  mounted() {
    if (this.items) {
      this.summaryItems = this.items
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/features/tcp/Broadcast/BroadcastSummary.vue